import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BatchImportModel } from '@data-layer/models/common';
import { enumBatchImportItemType } from '@data-layer/enums/common';

@Component({
  selector: 'app-batch-review',
  templateUrl: './batch-review.component.html',
  styleUrls: ['./batch-review.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BatchReviewComponent {
  @Input() public batchItem: BatchImportModel;

  constructor() {}

  public get routerLink(): string[] {
    if (!this.batchItem) {
      return;
    }

    return ['/', this.isISF ? 'isf' : 'entry-summary', 'batch', this.batchItem.id?.toString()];
  }

  public get isISF(): boolean {
    return this.batchItem.itemType === enumBatchImportItemType.ISF;
  }
}
